import Moment from 'moment';

const castToIsoDate = date => {
  return Moment(date).format('YYYY-MM-DD');
}

const keyToCasterMap = new Map([
  ['data.personal.information.birthday', castToIsoDate],
  ['data.studies.academic.date', castToIsoDate],
  ['data.studies.universityEntranceQualification.entrance.date', castToIsoDate],
  ['data.studies.previousStudies.exmatriculation.date', castToIsoDate],
  ['data.studies.previousStudies.domestic.0.start', castToIsoDate],
  ['data.studies.previousStudies.domestic.0.end', castToIsoDate],
  ['data.studies.previousStudies.domestic.1.start', castToIsoDate],
  ['data.studies.previousStudies.domestic.1.end', castToIsoDate],
  ['data.studies.previousStudies.domestic.2.start', castToIsoDate],
  ['data.studies.previousStudies.domestic.2.end', castToIsoDate],
  ['data.studies.previousStudies.domestic.3.start', castToIsoDate],
  ['data.studies.previousStudies.domestic.3.end', castToIsoDate],
  ['data.studies.previousStudies.domestic.4.start', castToIsoDate],
  ['data.studies.previousStudies.domestic.4.end', castToIsoDate],
  ['data.studies.previousStudies.foreign.0.start', castToIsoDate],
  ['data.studies.previousStudies.foreign.0.end', castToIsoDate],
  ['data.studies.previousStudies.foreign.1.start', castToIsoDate],
  ['data.studies.previousStudies.foreign.1.end', castToIsoDate],
  ['data.studies.previousStudies.foreign.2.start', castToIsoDate],
  ['data.studies.previousStudies.foreign.2.end', castToIsoDate],
  ['data.studies.previousStudies.foreign.3.start', castToIsoDate],
  ['data.studies.previousStudies.foreign.3.end', castToIsoDate],
  ['data.studies.previousStudies.foreign.4.start', castToIsoDate],
  ['data.studies.previousStudies.foreign.4.end', castToIsoDate],
  ['data.studies.job.experience.0.start', castToIsoDate],
  ['data.studies.job.experience.0.end', castToIsoDate],
  ['data.studies.job.experience.1.start', castToIsoDate],
  ['data.studies.job.experience.1.end', castToIsoDate],
  ['data.studies.job.experience.2.start', castToIsoDate],
  ['data.studies.job.experience.2.end', castToIsoDate],
  ['data.studies.job.experience.3.start', castToIsoDate],
  ['data.studies.job.experience.3.end', castToIsoDate],
  ['data.studies.job.experience.4.start', castToIsoDate],
  ['data.studies.job.experience.4.end', castToIsoDate],
]);

export default function serializeApplication(schema) {
  return data => {
    const casted = schema.cast(data);
    keyToCasterMap.forEach((caster, key) => {
      const steps = key.split('.');
      const prop = steps.pop();
      const root = steps.reduce(
        (o, k) => (o.hasOwnProperty(k) ? o[k] : o),
        casted
      );
      const val = root[prop];
      if (val) {
        root[prop] = caster(val);
      }
    });

    const serialized = JSON.stringify(casted, (key, val) => {
      if (val === '') {
        return undefined;
      }
      if (
        !Array.isArray(val) &&
        typeof val === 'object' &&
        val instanceof File &&
        Object.keys(val).length === 0
      ) {
        return undefined;
      }

      return val;
    });

    return serialized;
  };
}
